module.exports = __webpack_public_path__ + "img/heather-robertson.88316c44.jpg";